<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      id="Vector"
      d="M10 16.7499C13.1066 16.7499 15.625 14.1249 15.625 10.7499C15.625 6.99795 12.3095 4.33302 10.948 3.3969C10.6286 3.17727 10.2049 3.27162 9.9826 3.58918L8.24613 6.06984C7.98731 6.43959 7.45739 6.48598 7.13825 6.16685C6.85479 5.88339 6.39224 5.88162 6.13797 6.19154C4.96265 7.62406 4.375 9.40878 4.375 10.7499C4.375 14.1249 6.8934 16.7499 10 16.7499ZM10 16.7499C11.2427 16.7499 12.25 15.6001 12.25 14.1817C12.25 12.6193 11.0027 11.481 10.3654 11.0015C10.1465 10.8367 9.85353 10.8367 9.6346 11.0015C8.99733 11.481 7.75 12.6193 7.75 14.1817C7.75 15.6001 8.75732 16.7499 10 16.7499Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />

  </svg>
</template>

<script>
export default {
  name: 'FlameIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
